<div class="gl-account-tree-selector">
  <mat-form-field class="flex-100">
    <mat-label>{{ 'labels.inputs.' + inputLabel | translate }}</mat-label>
    <input
      matInput
      type="text"
      readonly
      [value]="selectedLabel"
      [placeholder]="'labels.inputs.Select Parent' | translate"
      (click)="openPanel()"
    />
    <button
      type="button"
      mat-icon-button
      matSuffix
      (click)="togglePanel()"
      [attr.aria-label]="'labels.buttons.Toggle parent tree' | translate"
    >
      <fa-icon [icon]="panelOpen ? 'chevron-up' : 'chevron-down'"></fa-icon>
    </button>
    @if (selectedLabel) {
      <button
        type="button"
        mat-icon-button
        matSuffix
        (click)="clearSelection($event)"
        [attr.aria-label]="'labels.buttons.Clear' | translate"
      >
        <fa-icon icon="times"></fa-icon>
      </button>
    }
    @if (required && inputFormControl.hasError('required')) {
      <mat-error>
        {{ 'labels.inputs.Account' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    }
  </mat-form-field>

  @if (panelOpen) {
    <div class="tree-dropdown-panel mat-elevation-z4">
      <div class="tree-dropdown-header">
        <mat-form-field class="flex-100">
          <mat-label>{{ 'labels.inputs.Search' | translate }}</mat-label>
          <input matInput type="text" [formControl]="filterControl" />
        </mat-form-field>
      </div>

      <div class="tree-dropdown-body">
        <mat-tree [dataSource]="nestedTreeDataSource" [treeControl]="nestedTreeControl" class="gl-account-tree">
          <mat-tree-node *matTreeNodeDef="let node">
            <li class="mat-tree-node">
              <button mat-icon-button disabled></button>
              <span
                class="tree-node-label"
                [class.disabled]="node.disabled"
                [class.selected]="inputFormControl.value === node.id"
                (click)="selectNode(node)"
              >
                {{ node.glCode ? '(' + node.glCode + ') ' + node.name : node.name }}
              </span>
            </li>
          </mat-tree-node>

          <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild">
            <li>
              <div class="mat-tree-node">
                <button
                  type="button"
                  mat-icon-button
                  matTreeNodeToggle
                  [attr.aria-label]="'toggle ' + node.name"
                >
                  <fa-icon
                    class="mat-icon-rtl-mirror"
                    [icon]="nestedTreeControl.isExpanded(node) ? 'chevron-down' : 'chevron-right'"
                  ></fa-icon>
                </button>
                <span
                  class="tree-node-label"
                  [class.disabled]="node.disabled"
                  [class.selected]="inputFormControl.value === node.id"
                  (click)="selectNode(node)"
                >
                  {{ node.glCode ? '(' + node.glCode + ') ' + node.name : node.name }}
                </span>
              </div>
              <ul [class.gl-account-tree-invisible]="!nestedTreeControl.isExpanded(node)">
                <ng-container matTreeNodeOutlet></ng-container>
              </ul>
            </li>
          </mat-nested-tree-node>
        </mat-tree>
      </div>

      <div class="tree-dropdown-footer">
        <button type="button" mat-button (click)="closePanel()">
          {{ 'labels.buttons.Close' | translate }}
        </button>
      </div>
    </div>
  }
</div>
